import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { createQueryCustomHook } from "../../../../stores/useQueryState";
import { Select } from "../../../../ui/Select/Select";
import { Label } from "../Label/Label";

const DLR = "DLR";
const CSO = "CSO";

type OrdertypeOption = typeof CSO | typeof DLR;

export const orderTypeOptions = [DLR, CSO];

export const useOrderTypeParam = createQueryCustomHook<OrdertypeOption>(
  "order-type",
  () =>
    (value): OrdertypeOption =>
      orderTypeOptions.includes(value as OrdertypeOption)
        ? (value as OrdertypeOption)
        : DLR
);

export const OrderTypeSelect: FunctionComponent = () => {
  const { t } = useTranslation();
  const [orderType, setOrderType] = useOrderTypeParam();
  return (
    <fieldset>
      <Label htmlFor="order-type-filter">{t("orderFilters.type")}</Label>
      <Select
        onChange={(event): void => {
          setOrderType(event.target.value as OrdertypeOption);
        }}
        aria-label="orderTypeFilter"
        className="w-full"
        id="order-type-filter"
        value={orderType}
      >
        {orderTypeOptions.map((option) => (
          <option key={option} value={option}>
            {Number(option) ? option : t(`orderFilters.${option}`)}
          </option>
        ))}
      </Select>
    </fieldset>
  );
};
